module.exports = __webpack_public_path__ + "16_vast.png?ff4bbed309f952b3bca4eba9e9074277";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/16_vast.png
// module id = 160
// module chunks = 0